import {
  addNavMenuItem,
  registerPageTab,
  addActionBarItem,
  addNavMenuSection,
  registerCustomDetailComponent,
} from "@bb-vendure/admin-ui/core";
import { registerFormInputComponent } from "@bb-vendure/admin-ui/core";
import { WarehouseDropdownComponent as WarehouseDropdownComponent2 } from "./warehouse-dropdown2/warehouse-dropdown.component";
import { SupplierPickerComponent } from "./supplier-dropdown/supplier-dropdown.component";
import { ShipmentStatusInfoComponent } from "./shipment-status-info/shipment-status-info.component";

export default [
  registerCustomDetailComponent({
    locationId: "order-detail",
    component: ShipmentStatusInfoComponent,
  }),

  // registerFormInputComponent(
  //   "warehouse-dropdown-input",
  //   WarehouseDropdownComponent
  // ),

  registerFormInputComponent(
    "warehouse-dropdown-input2",
    WarehouseDropdownComponent2
  ),

  registerFormInputComponent("supplier-picker", SupplierPickerComponent),
  // TODO avoid duplicate with menu section

  addNavMenuItem(
    {
      id: "ware-house",
      label: "nav.warehouse-management",
      routerLink: ["/extensions/ware-house"],
      icon: "bundle",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadWarehouse");
      },
    },
    "rule-section"
  ),
  // addNavMenuItem(
  //   {
  //     id: "supplier",
  //     label: "Supplier Management",
  //     routerLink: ["/extensions/supplier"],
  //     icon: "bundle",
  //   },
  //   "ware-house"
  // ),
  // addNavMenuItem(
  //   {
  //     id: "wh-product",
  //     label: "W/H Product Management",
  //     routerLink: ["/extensions/wh-product"],
  //     icon: "bundle",
  //   },
  //   "ware-house-section"
  // ),
];
